"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var irt_1 = require("@playq/irt");
var ThreadMessage_1 = require("./ThreadMessage");
var MessageBase_1 = require("./MessageBase");
var MessageReceivedData_1 = require("./MessageReceivedData");
var MessageData_1 = require("./MessageData");
var ServerMessage_1 = require("./ServerMessage");
var MessageSender_1 = require("./MessageSender");
var MessageSentData_1 = require("./MessageSentData");
var MessageReceiver_1 = require("./MessageReceiver");
var Message = (function () {
    function Message(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            this.thread = [];
            return;
        }
        this.receiver = MessageReceiver_1.MessageReceiverHelpers.deserialize(data.receiver);
        this.sender = MessageSender_1.MessageSenderHelpers.deserialize(data.sender);
        this.messageId = data.messageId;
        this.msgData = MessageData_1.MessageDataHelpers.deserialize(data.msgData);
        this.serverTimestampAsString = data.serverTimestamp;
        this.thread = data.thread.map(function (e) { return new ThreadMessage_1.ThreadMessage(e); });
        this.threadMessagesCounter = data.threadMessagesCounter;
    }
    Message.prototype.getPackageName = function () { return Message.PackageName; };
    Message.prototype.getClassName = function () { return Message.ClassName; };
    Message.prototype.getFullClassName = function () { return Message.FullClassName; };
    Object.defineProperty(Message.prototype, "receiver", {
        get: function () {
            return this._receiver;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field receiver is not optional');
            }
            this._receiver = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "sender", {
        get: function () {
            return this._sender;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sender is not optional');
            }
            this._sender = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "messageId", {
        get: function () {
            return this._messageId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field messageId is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field messageId expects type string, got ' + value);
            }
            if (!value.match('^[0-9a-fA-f]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$')) {
                throw new Error('Field messageId expects guid format, got ' + value);
            }
            this._messageId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "msgData", {
        get: function () {
            return this._msgData;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field msgData is not optional');
            }
            this._msgData = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "serverTimestamp", {
        get: function () {
            return this._serverTimestamp;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field serverTimestamp is not optional');
            }
            if (!(value instanceof Date)) {
                throw new Error('Field serverTimestamp expects type Date, got ' + value);
            }
            this._serverTimestamp = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "serverTimestampAsString", {
        get: function () {
            return irt_1.Formatter.writeZoneDateTime(this._serverTimestamp);
        },
        set: function (value) {
            if (typeof value !== 'string') {
                throw new Error('serverTimestampAsString expects type string, got ' + value);
            }
            this._serverTimestamp = irt_1.Formatter.readZoneDateTime(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "thread", {
        get: function () {
            return this._thread;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field thread is not optional');
            }
            this._thread = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "threadMessagesCounter", {
        get: function () {
            return this._threadMessagesCounter;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field threadMessagesCounter is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field threadMessagesCounter expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field threadMessagesCounter is expected to be an integer, got ' + value);
            }
            if (value < 0) {
                throw new Error('Field threadMessagesCounter is expected to be not less than 0, got ' + value);
            }
            if (value > 4294967295) {
                throw new Error('Field threadMessagesCounter is expected to be not greater than 4294967295, got ' + value);
            }
            this._threadMessagesCounter = value;
        },
        enumerable: false,
        configurable: true
    });
    Message.prototype.toServerMessageSerialized = function () {
        return {
            receiver: MessageReceiver_1.MessageReceiverHelpers.serialize(this.receiver),
            sender: MessageSender_1.MessageSenderHelpers.serialize(this.sender),
            messageId: this.messageId,
            msgData: MessageData_1.MessageDataHelpers.serialize(this.msgData),
            serverTimestamp: this.serverTimestampAsString
        };
    };
    Message.prototype.toServerMessage = function () {
        return new ServerMessage_1.ServerMessageStruct(this.toServerMessageSerialized());
    };
    Message.prototype.toMessageBaseSerialized = function () {
        return {
            receiver: MessageReceiver_1.MessageReceiverHelpers.serialize(this.receiver),
            msgData: MessageData_1.MessageDataHelpers.serialize(this.msgData)
        };
    };
    Message.prototype.toMessageBase = function () {
        return new MessageBase_1.MessageBaseStruct(this.toMessageBaseSerialized());
    };
    Message.prototype.toMessageReceivedDataSerialized = function () {
        return {
            receiver: MessageReceiver_1.MessageReceiverHelpers.serialize(this.receiver)
        };
    };
    Message.prototype.toMessageReceivedData = function () {
        return new MessageReceivedData_1.MessageReceivedDataStruct(this.toMessageReceivedDataSerialized());
    };
    Message.prototype.toMessageSentDataSerialized = function () {
        return {
            sender: MessageSender_1.MessageSenderHelpers.serialize(this.sender),
            messageId: this.messageId
        };
    };
    Message.prototype.toMessageSentData = function () {
        return new MessageSentData_1.MessageSentDataStruct(this.toMessageSentDataSerialized());
    };
    Message.prototype.loadServerMessageSerialized = function (slice) {
        this.receiver = MessageReceiver_1.MessageReceiverHelpers.deserialize(slice.receiver);
        this.sender = MessageSender_1.MessageSenderHelpers.deserialize(slice.sender);
        this.messageId = slice.messageId;
        this.msgData = MessageData_1.MessageDataHelpers.deserialize(slice.msgData);
        this.serverTimestampAsString = slice.serverTimestamp;
    };
    Message.prototype.loadServerMessage = function (slice) {
        this.loadServerMessageSerialized(slice.serialize());
    };
    Message.prototype.loadMessageBaseSerialized = function (slice) {
        this.receiver = MessageReceiver_1.MessageReceiverHelpers.deserialize(slice.receiver);
        this.msgData = MessageData_1.MessageDataHelpers.deserialize(slice.msgData);
    };
    Message.prototype.loadMessageBase = function (slice) {
        this.loadMessageBaseSerialized(slice.serialize());
    };
    Message.prototype.loadMessageReceivedDataSerialized = function (slice) {
        this.receiver = MessageReceiver_1.MessageReceiverHelpers.deserialize(slice.receiver);
    };
    Message.prototype.loadMessageReceivedData = function (slice) {
        this.loadMessageReceivedDataSerialized(slice.serialize());
    };
    Message.prototype.loadMessageSentDataSerialized = function (slice) {
        this.sender = MessageSender_1.MessageSenderHelpers.deserialize(slice.sender);
        this.messageId = slice.messageId;
    };
    Message.prototype.loadMessageSentData = function (slice) {
        this.loadMessageSentDataSerialized(slice.serialize());
    };
    Message.prototype.serialize = function () {
        return {
            receiver: MessageReceiver_1.MessageReceiverHelpers.serialize(this.receiver),
            sender: MessageSender_1.MessageSenderHelpers.serialize(this.sender),
            messageId: this.messageId,
            msgData: MessageData_1.MessageDataHelpers.serialize(this.msgData),
            serverTimestamp: this.serverTimestampAsString,
            thread: this.thread.map(function (e) { return e.serialize(); }),
            threadMessagesCounter: this.threadMessagesCounter
        };
    };
    Message.PackageName = 'net.playq.services.teams';
    Message.ClassName = 'Message';
    Message.FullClassName = 'net.playq.services.teams.Message';
    return Message;
}());
exports.Message = Message;
ServerMessage_1.ServerMessageStruct.register(Message.FullClassName, Message);
MessageBase_1.MessageBaseStruct.register(Message.FullClassName, Message);
MessageReceivedData_1.MessageReceivedDataStruct.register(Message.FullClassName, Message);
MessageSentData_1.MessageSentDataStruct.register(Message.FullClassName, Message);
var irt_2 = require("@playq/irt");
irt_2.Introspector.register(Message.FullClassName, {
    full: Message.FullClassName,
    short: Message.ClassName,
    package: Message.PackageName,
    type: irt_2.IntrospectorTypes.Data,
    ctor: function () { return new Message(); },
    fields: [
        {
            name: 'receiver',
            accessName: 'receiver',
            type: { intro: irt_2.IntrospectorTypes.Adt, full: 'net.playq.services.teams.MessageReceiver' }
        },
        {
            name: 'sender',
            accessName: 'sender',
            type: { intro: irt_2.IntrospectorTypes.Adt, full: 'net.playq.services.teams.MessageSender' }
        },
        {
            name: 'messageId',
            accessName: 'messageId',
            type: { intro: irt_2.IntrospectorTypes.Uid }
        },
        {
            name: 'msgData',
            accessName: 'msgData',
            type: { intro: irt_2.IntrospectorTypes.Adt, full: 'net.playq.services.teams.MessageData' }
        },
        {
            name: 'serverTimestamp',
            accessName: 'serverTimestamp',
            type: { intro: irt_2.IntrospectorTypes.Tsz }
        },
        {
            name: 'thread',
            accessName: 'thread',
            type: { intro: irt_2.IntrospectorTypes.List, value: { intro: irt_2.IntrospectorTypes.Data, full: 'net.playq.services.teams.ThreadMessage' } }
        },
        {
            name: 'threadMessagesCounter',
            accessName: 'threadMessagesCounter',
            type: { intro: irt_2.IntrospectorTypes.U32 }
        }
    ]
});
//# sourceMappingURL=Message.js.map